import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './ideas.css';
import { NavLink } from 'react-router-dom';

const EditIdea = (props) => {
    const [params] = useState(props.match.params);
    const [user] = useState(JSON.parse(localStorage.getItem('user')));
    const [message, setMessage] = useState({
        type: null,
        text: ''
    })

    const [idea, setIdea] = useState({ id: params.id, description: '' });

    const handleChange = (e) => {
        e.preventDefault()
        let name = e.target.name;
        let value = e.target.value;
        setIdea(prevState => {
            return {
                ...prevState,
                [name]: value
            }
        });
    }

    
    const resetMessage = (e) => {
        setMessage(() => {
            return {
                type: null,
                message: ''
            }
        });
    }

    const saveIdea = async (e) => {
        e.preventDefault();
        let error = false;
        if (idea.title === '') {
            error = true;
            setMessage(() => {
                return {
                    type: 'danger',
                    message: 'Please enter Idea title.'
                }
            });
            return;
        }
        if (idea.description === '') {
            error = true;
            setMessage(() => {
                return {
                    type: 'danger',
                    message: 'Please enter Idea description.'
                }
            });
            return;
        }

        
        if (!error) {
            await axios.put(
                localStorage.getItem('basurl') + '/ideas', {
                language:idea.language,
                id: idea.id,
                title: idea.title,
                description: idea.description,
                medias: idea.medias,
                featured: idea.featured
            }, { headers: { 'mojo-access-tokens': user.token } }
            ).then(response => {
                setMessage(() => {
                    return {
                        type: 'success',
                        message: response.data.message
                    }
                });
               
                setIdea({ title: '', description: '' });
            }).catch(error => {
                setMessage(() => {
                    return {
                        type: 'danger',
                        message: error.response.data.message
                    }
                });
            });
        }

    }

    const getMessage = () => {
        if (message.type) {
            return (<div className={`alert alert-${message.type}`} role="alert">
                <button type="button" className="close" onClick={resetMessage}>
                    <span aria-hidden="true">&times;</span>
                </button>
                <strong className="d-block d-sm-inline-block-force">{message.type === 'success' ? 'Well done!' : 'Oops!'}</strong> {message.message}
            </div>)
        }
    }

    

    

    const getIdea = async () => {
        try {
            await axios.get(localStorage.getItem('basurl') + '/ideas/' + params.id, {
                headers: {
                    'mojo-access-tokens': user.token
                }
            }
            ).then(response => {
                response.data.forEach((value) => {
                    let val = value;
                    let media = [];
                    for (let x in value.medias) {
                        media.push(value.medias[x].media_id);
                        if (value.medias[x].featured) {
                            val.featured = value.medias[x].media_id
                        }
                    }
                    val['medias'] = media;
                    setIdea(prevState => {
                        return {
                            ...prevState,
                            ...val
                        }
                    });
                })                
            }).catch(error => {
                if (typeof error.response.data !== undefined && error.response.data.loginRequired) {
                    //localStorage.removeItem('user');
                    //window.location.href = '/login';
                }
                console.log(error);
            });
        } catch (err) {
            console.log(err);
        }
    }
    
    

    useEffect(() => {
        getIdea();
    }, [])

    return (<>
        <div className="card shadow-base bd-0 pd-20">
            <p className="mg-b-30 tx-gray-600">Fields masked with <span className="tx-danger">*</span> are required.</p>
            {getMessage()}
            <div className="row mg-t-20">
                <label className="col-sm-2 form-control-label">Idea Description: <span className="tx-danger">*</span></label>
                <div className="col-sm-10 mg-t-10 mg-sm-t-0">
                    <textarea name="description" rows={6} className="form-control" placeholder="Enter idea description" autoComplete="off" onFocus={resetMessage} onChange={handleChange} value={idea.description} />
                </div>
            </div>
            
            <div className="form-layout-footer mg-t-30 tx-right">
                <NavLink to="/ideas"> My Ideas </NavLink> &nbsp; &nbsp; &nbsp;
                <button onClick={saveIdea} className="btn btn-info" style={{ cursor: 'pointer' }}>Save</button>&nbsp;&nbsp;
            </div>
        </div>
    </>);
}

export default EditIdea;